export default __webpack_public_path__ + "static/media/17_the_queen.a06b2d9b.png";